import React from "react";
import moment from "moment";

const NotificationHistoryTableRow = ({
  author,
  type,
  created,
  sent,
  status,
  reach,
  hasBgColor
}) => {

  const dateCreatedFormat = created != null ? moment(created).format("D MMM YYYY") : "";
  const dateSentFormat = formatDates(sent);

  //if a date is scheduled for future, set it it "-", otherwise format it
  function formatDates(sentDate: string){
    const todayDate = new Date();
    const checkSentDate = new Date(sentDate);
    if (checkSentDate.getTime() > todayDate.getTime()){
      return "-"
    } else {
      return moment(sent).format("D MMM YYYY");
    }
  }

  let notificationType: string;
  if (type === 0){
    notificationType = 'In App Only';
  } else if (type === 1){
    notificationType = 'In App + Push'
  } else {
    notificationType = '-';
  }
  let statusType: string;
  if (status === 0){
    statusType = 'Cancelled'
  } else if (status === 1){
    statusType = "Sent"
  } else {
    statusType = "Scheduled"
  }

  const truncatedAuthorName = (authorName: string, maxLength: number) => {
    if (authorName.length > maxLength) {
      return authorName.slice(0, maxLength) + '...';
    }
    return authorName;
  }

  return (
    <tr
      className={`notification-history-table-row ${hasBgColor ? "" : "has-bg-color"}`}
    >
      <td className="author author-tooltip" title={author}>{truncatedAuthorName(author, 15)}</td>
      <td className="type">{notificationType}</td>
      <td className="dateCreated">{dateCreatedFormat === 'Invalid date' ? "-" : dateCreatedFormat}</td>
      <td className="dateSent">{dateSentFormat === 'Invalid date' ? "-" : dateSentFormat}</td>
      <td className="status">{statusType}</td>
      <td className="audienceReach">
        {status === 1 ? reach : "-"}
      </td>
    </tr>
  );
};

export default NotificationHistoryTableRow;
